import { mockResponse, request, isMockMode } from './client.js';
import { USER_ROLES } from '../constants/userRoles.js';

const CUSTOMER_USER = {
  id: 'u-001',
  email: 'player@michidart.tw',
  name: '王家瑋',
  initial: '王',
  role: USER_ROLES.CUSTOMER,
  permissions: [],
  tier: 'GOLD',
  points: 1444,
  totalSpent: 5160,
  orderCount: 7,
  tierProgress: { current: 5160, target: 8000 },
};

const ADMIN_USER = {
  id: 'a-001',
  email: 'admin@michidart.tw',
  name: '管理員',
  initial: '管',
  role: USER_ROLES.ADMIN,
  permissions: ['dashboard', 'theme', 'virtual', 'product', 'catalog', 'order', 'inquiry', 'users', 'roles'],
};

// Auth 類 API 只要有設定後端就打真實，不受 REACT_APP_USE_MOCK 影響
const hasBackend = !!process.env.REACT_APP_API_BASE_URL;

export function login({ email, password }) {
  if (hasBackend) return request('/api/auth/login', { method: 'POST', body: { email, password } });
  return mockResponse(() => {
    const isAdmin = email?.toLowerCase().includes('admin');
    return {
      user: isAdmin ? ADMIN_USER : CUSTOMER_USER,
      token: isAdmin ? 'mock-admin-token' : 'mock-customer-token',
    };
  });
}

export function register({ username, email, password, inviteCode }) {
  if (hasBackend) return request('/api/auth/register', { method: 'POST', body: { username, email, password, inviteCode } });
  return mockResponse({
    user: { ...CUSTOMER_USER, name: username, email },
    token: 'mock-customer-token',
  });
}

export function getProfile() {
  if (hasBackend) return request('/api/auth/me');
  return mockResponse(CUSTOMER_USER);
}

// 點驗證信連結後呼叫：把 token 送回後端完成 Email 驗證
export function verifyEmail(token) {
  if (hasBackend) return request('/api/auth/verify-email', { method: 'POST', body: { token } });
  return mockResponse({ message: 'Email 驗證成功' });
}

// 重寄驗證信（需登入）
export function resendVerification() {
  if (hasBackend) return request('/api/auth/resend-verification', { method: 'POST' });
  return mockResponse({ message: '驗證信已重新寄出' });
}

// 忘記密碼：請求寄送重設連結（後端防列舉，不論 email 是否存在都回成功）
export function forgotPassword(email) {
  if (hasBackend) return request('/api/auth/forgot-password', { method: 'POST', body: { email } });
  return mockResponse({ message: '若該 Email 已註冊，我們已寄出密碼重設連結' });
}

// 用重設連結的 token 設定新密碼
export function resetPassword(token, password) {
  if (hasBackend) return request('/api/auth/reset-password', { method: 'POST', body: { token, password } });
  return mockResponse({ message: '密碼已重設' });
}

// Refresh Token Rotation 下同時間只能有一個 refresh 進行中。
// 不管哪個呼叫者（silentRefresh、doRefresh、client.js 自動 retry）都共用這個 promise，
// 避免 race condition 把 DB 裡的 refresh_token 撞掉。
let _refreshPromise = null;

export function refreshToken() {
  if (_refreshPromise) return _refreshPromise;

  // refresh_token 由瀏覽器自動帶 httpOnly cookie，不需要手動傳
  const promise = hasBackend
    ? request('/api/auth/refresh', { method: 'POST' })
    : mockResponse({ user: CUSTOMER_USER, token: 'mock-customer-token' });

  _refreshPromise = promise.finally(() => { _refreshPromise = null; });
  return _refreshPromise;
}

export function logout() {
  // refresh_token 由瀏覽器自動帶 httpOnly cookie，後端讀 cookie 清除
  if (hasBackend) return request('/api/auth/logout', { method: 'POST' });
  return mockResponse({ ok: true });
}
